import React from 'react'

export const CustomCardRestorePassw = ({ children }) => {
    return (
        <div className="flex flex-col w-[612px] h-[560px] bg-[#1B1464] rounded shadow-blue">
            {children}
        </div>
    )
}

export default CustomCardRestorePassw